export default function notify(error) {
  if (typeof window.Bugsnag !== 'undefined') {
    window.Bugsnag.notify(error);
  }
}
